import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import toaster from 'toasted-notes';
import CheckBox from 'react-bootstrap/FormCheckInput';
import { serverEnvironment } from '../../../hooks/store/actionConsts';
import { connect } from 'react-redux';
import Select from 'react-styled-select';
import swal from 'sweetalert';
import Container from 'react-bootstrap/Container';
import { getContactsByUser, saveIcon } from '../../../hooks/store/actions/contactActions';
import { register, editUserProfile, showEditUserForm , deactivateUser, reactivateUser} from '../../../hooks/store/actions/loginActions';

const COACHING_TYPE_OPTIONS = [
    'Life Coaching',
    'Career Coaching',
    'Business Coaching',
    'Executive Coaching',
    'Health and Wellness Coaching',
    'Relationship Coaching',
    'Financial Coaching',
    'Leadership Coaching',
    'Mindset Coaching',
    'Parenting Coaching',
    'Public Speaking Coaching',
    'Spiritual Coaching',
    'Sales Coaching',
    'Creative Coaching',
    'Other',
];

function parseCoachingTypes(value) {
    if (!value) return [];
    return String(value).split(',').map((item) => item.trim()).filter(Boolean);
}

class UserProfile extends React.Component {
    constructor(props) {

        super(props);
        this.state = {            
            ...props.user,
            isActive: true,
            isDirty: false,
            tempLogo: null,
            dropdownOpen: false,
            dropdownOpenUserRole: false,
            userRoleDisplay: this.setUserRoleDisplay(this.props.user.userRole),
            gender: props.user.gender || '',
            ageRange: props.user.ageRange || '',
            location: props.user.location || '',
            ctpProgramName: props.user.ctpProgramName || '',
            ctpProgramYearStart: props.user.ctpProgramYearStart || '',
            ctpProgramYearEnd: props.user.ctpProgramYearEnd || '',
            icfCredentials: props.user.icfCredentials || '',
            otherProfessionalCredentials: props.user.otherProfessionalCredentials || '',
            businessEmail: props.user.businessEmail || '',
            coachingTypeOther: props.user.coachingTypeOther || '',
        };

        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.onCheckInclude = this.onCheckInclude.bind(this);
        this.onSelectUserRole = this.onSelectUserRole.bind(this);
        this.onClickDeactivate = this.onClickDeactivate.bind(this);
        this.onClickReactivate = this.onClickReactivate.bind(this);
        this.onCheckAccessDocs = this.onCheckAccessDocs.bind(this);
        this.onCheckCoachApproval = this.onCheckCoachApproval.bind(this);

        this.setUserRoleDisplay();
    };

    onChange = (e) => {  
        this.setState({ [e.target.id]: e.target.value, isDirty: true });
    }

    onToggleCoachingType = (option) => {
        const selected = parseCoachingTypes(this.state.coachingType);
        const next = selected.includes(option)
            ? selected.filter((item) => item !== option)
            : [...selected, option];
        this.setState({ coachingType: next.join(','), isDirty: true });
    }

    toggle = () => this.setState({ dropdownOpen: !this.state.dropdownOpen });
    toggleUserRole = () => this.setState({ dropdownOpenUserRole: !this.state.dropdownOpenUserRole });
    onChangeAffiliateType = (newAffiliateFeeType) => this.setState({ affiliateFeeType: newAffiliateFeeType, isDirty: true });

    setUserRoleDisplay = (userRole) => {
        var result = "Affiliate"
        if (userRole === 2) { result = "Affiliate" }
        if (userRole === 3) { result = "Office Staff" }
        if (userRole === 8) { result = "Finance" }
        return result
    }

    pwdCheck(PW, Email) {

        //^ The password string will start this way
        //(?=.*[A-Za-z])	The string must contain at least 1 alphabetical character
        //(?=.*[0-9])		The string must contain at least 1 numeric character
        //(?=.*[.!@#$%^&*])	The string must contain at least one special character, but we are escaping reserved RegEx characters to avoid conflict
        //(?=.{8,})			The string must be eight characters or longer

            var regEx = new RegExp("^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[.!@#\$%\^&\*])(?=.{8,})");
            var msg = "";

        if (Email.toLowerCase() == PW.toLowerCase()) {
            //alert('Your password can not be the same as your email address');
            msg = 'Your password can not be the same as your email address';
            return msg;
        }

        if (regEx.test(PW)) {
            //alert('password is good');
            return false;
        } else {
            //alert('Your password does not meet our minimum requirements. It must be at least 8 characters long containing at least one number, one letter and one special character');
            //msg = 'Your password does not meet our minimum requirements. It must be at least 8 characters long containing at least one number, one letter and one special character';
            msg = 'Password entered does not meet minimum requirements.';
            return msg;
        }

    }

    onClick = (e) => {
        if (this.state.isDirty) {

            if (this.props.user.userID) {

                var email = this.state.email;
                var firstName = this.state.firstName;
                var lastName = this.state.lastName;
                var phone = this.state.phone;
                var logoURL = this.state.logoURL;
                var includeLogoURL = this.state.includeLogoURL;
                var programInformation = this.state.programInformation;
                var certsAndCredentials = this.state.certsAndCredentials;
                var affiliateFeeType = this.state.affiliateFeeType;
                var userRole = this.state.userRole;
                var accessDocs = this.state.canAccessDocs;
                var isLive = this.state.isLive;
                var website = this.state.website;
                var companyName = this.state.companyName;
                var coachingType = this.state.coachingType;
                var gender = this.state.gender;
                var ageRange = this.state.ageRange;
                var location = this.state.location;
                var ctpProgramName = this.state.ctpProgramName;
                var ctpProgramYearStart = this.state.ctpProgramYearStart;
                var ctpProgramYearEnd = this.state.ctpProgramYearEnd;
                var icfCredentials = this.state.icfCredentials;
                var otherProfessionalCredentials = this.state.otherProfessionalCredentials;
                var businessEmail = this.state.businessEmail;
                var coachingTypeOther = this.state.coachingTypeOther;

                if ((!firstName || (firstName && firstName === ""))) {
                    toaster.notify("First Name is required.", { duration: 4000 });
                    return;
                }
                if ((!lastName || (lastName && lastName === ""))) {
                    toaster.notify("Last Name is required.", { duration: 4000 });
                    return;
                }
                if (!email || (email && email === "")) {
                    toaster.notify("Email is required.", { duration: 4000 });
                    return;
                }
                if ((!phone || (phone && phone === ""))) {
                    toaster.notify("Primary Phone is required.", { duration: 4000 });
                    return;
                }

                if (email !== this.props.user.email) {
                    swal({
                        //title: "Username Change", text: "Are you absolutely sure you want to change your Username? If you change this field, you will need to use this new username/email to login to the AC Admin Hub from now on. Please be sure the spelling is correct and that this is an email you have access to in case you forget your password.\n\nConfirm Change?", icon: "warning",
                        title: "Username Change", text: "Are you absolutely sure you want to change this Affiliate Username? If you change this field, the Affiliate will need to use this new username to login to the AC Admin Hub from now on. Please be sure the spelling is correct and that this is an email that the Affiliate has access to in case they forget their password.\n\nConfirm Change?", icon: "warning",
                        buttons:
                        {
                            no: {
                                text: "No",
                                value: "no"
                            },
                            yes: {
                                text: "Yes",
                                value: "yes"
                            }
                        }
                    }).then((value) => {
                        switch (value) {
                            case "yes":
                                this.props.editUserProfile(this.props.token, this.props.user, email.trim(), firstName.trim(),
                                    lastName.trim(), phone, logoURL, includeLogoURL, '', '', programInformation, certsAndCredentials,
                                    affiliateFeeType, userRole, accessDocs, isLive, website, coachingType, companyName, gender, ageRange, location,
                                    ctpProgramName, ctpProgramYearStart, ctpProgramYearEnd, icfCredentials, otherProfessionalCredentials, businessEmail, coachingTypeOther);
                                this.setState({ isDirty: false });
                                break;
                            case "no":
                                break;
                            default:
                                break;
                        }
                    });
                } else {
                    this.props.editUserProfile(this.props.token, this.props.user, email.trim(), firstName.trim(),
                        lastName.trim(), phone, logoURL, includeLogoURL, '', '', programInformation, certsAndCredentials,
                        affiliateFeeType, userRole, accessDocs, isLive, website, coachingType, companyName, gender, ageRange, location,
                        ctpProgramName, ctpProgramYearStart, ctpProgramYearEnd, icfCredentials, otherProfessionalCredentials, businessEmail, coachingTypeOther);
                    this.setState({ isDirty: false });
                }
            }
            else {
                var item = { ...this.state }; // update everything

                if (item.password) {

                    var pwdCheck = this.pwdCheck(item.password, item.email);
                    //alert(pwdCheck)
                    if (pwdCheck) { 
                        toaster.notify(pwdCheck, { duration: 4000 });
                        return;
                    }

                    //item.forcePasswordChange = true; // force new user to change their password
                    this.props.register(item);
                }
                else {
                    toaster.notify("Password is required", { duration: 4000 });
                    return;
                }
            }
            this.setState({ isDirty: false });

            this.props.showEditUserForm(false);
        }
        else {
            if (this.props.user.userID) {
                toaster.notify("Not Saved - Nothing Has Been Changed", { duration: 4000 });
                this.onClickCancel();
            }
            else {
                toaster.notify("Password is required", { duration: 4000 });
                return;
            }
        }        
    }

    onClickDeactivate() {
        swal({
            title: "AC Admin", text: "Deactivate this user?", icon: "warning",
            buttons:
            {
                no: {
                    text: "No",
                    value: "no"
                },
                yes: {
                    text: "Yes",
                    value: "yes"
                },
                cancel: false
            }
        }).then((value) => {
            switch (value) {
                case "yes":

                    this.props.deactivateUser(this.props.token, this.props.user.userID);
                    this.props.showEditUserForm(false);
                    break;
                case "no":
                    break;
                default:
                    break;
            }
        });
    }

    onClickReactivate() {
        swal({
            title: "AC Admin", text: "Reactivate this user?", icon: "warning",
            buttons:
            {
                no: {
                    text: "No",
                    value: "no"
                },
                yes: {
                    text: "Yes",
                    value: "yes"
                },
                cancel: false
            }
        }).then((value) => {
            switch (value) {
                case "yes":

                    this.props.reactivateUser(this.props.token, this.props.user);
                    this.props.showEditUserForm(false);
                    break;
                case "no":
                    break;
                default:
                    break;
            }
        });
    }

    onClickCancel = (e) => {
        this.setState({ isDirty: false });
        this.props.showEditUserForm(false);
    }

    onCheckInclude(e) {
        this.setState({ isDirty: true});
        this.setState({ 'includeLogoURL': e.target.checked });
    }

    onCheckAccessDocs(e) {
        this.setState({ isDirty: true});
        this.setState({ canAccessDocs: !this.state.canAccessDocs });
    }

    onCheckCoachApproval(e) {
        this.setState({ isDirty: true});
        this.setState({ isLive : !this.state.isLive });
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    onChangeFile = (e) => {
        this.setState({ "fileName": e.target.files[0], isDirty: true });

        if (e.target.files[0]) {
            var fn = e.target.files[0];

            // 1. Ensure a valid file is selected
            var reader = new FileReader();
            if (fn.size) {
                var fileName = fn.name;
                if (fileName.indexOf(".") > 0) {
                    fileName = fileName.substring(0, fileName.indexOf("."));
                }
                reader.onload = function (e) {

                    var contents = e.target.result;
                    this.setState({ "tempLogo": contents });
                    this.props.saveIcon(this.props.token, this.props.user.userID, fileName, contents);

                }.bind(this);
                reader.readAsDataURL(fn);
                this.setState({ logoURL: serverEnvironment.API_URL + "/image/" + String(this.props.user.userID) + "/" + fileName });
            }
        }
    } 

    onSelectUserRole(item) {
        this.setState({ userRole: item, isDirty: true });
        this.setState({ userRoleDisplay: this.setUserRoleDisplay(item) });
    }
    
    render() {
        
        return (            
                <Modal.Body className="full-screen" style={{padding: '30px 40px', maxHeight: '85vh', overflowY: 'auto'}}>
                    <Container className="Modal.Body form-editcontact modal-small" style={{maxWidth: '900px', margin: '0 auto', paddingLeft: '20px', paddingRight: '20px'}}>
                        <Form.Group as={Row}>                       
                            <Form.Label column sm={2}>
                                User Role
                            </Form.Label>
                        <Col sm={8}>

                            <Dropdown isOpen={this.state.dropdownOpenUserRole} toggle={this.toggleUserRole}>
                                <DropdownToggle className="ddStyle" caret>
                                    {this.state.userRoleDisplay ? this.state.userRoleDisplay + ' ' : 'User Role'}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem header>User Role</DropdownItem>
                                    <DropdownItem disabled>{this.state.userRole <= 2 ? "Affiliate" : this.state.userRoleDisplay} <i>(current selection)</i></DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem></DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onSelectUserRole(2)}>Affiliate</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onSelectUserRole(3)}>Office Staff</DropdownItem>
                                    <DropdownItem disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) ? false : true} className={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) ? 'text-primary' : 'text-secondary' } onClick={() => this.onSelectUserRole(8)}>Finance</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>

                        </Col>                        
                     </Form.Group>
                    <Form.Group as={Row}>
                        <Form.Label column sm={2}>
                            First Name&nbsp;<span style={{ color: 'red' }}>*</span>
                        </Form.Label>
                        <Col sm={8}>
                            <Form.Control id="firstName" placeholder="First Name" onChange={this.onChange} value={this.state.firstName} defaultValue={this.props.user.firstName} disabled={ (this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true } />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                        <Form.Label column sm={2}>
                            Last Name&nbsp;<span style={{ color: 'red' }}>*</span>
                    </Form.Label>
                        <Col sm={8}>
                            <Form.Control id="lastName" placeholder="Last Name" onChange={this.onChange} value={this.state.lastName} defaultValue={this.props.user.lastName} disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                        <Form.Label column sm={2}>
                            Username&nbsp;<span style={{ color: 'red' }}>*</span>
                    </Form.Label>
                        <Col sm={5}>
                            <Form.Control id="email" type="email" placeholder="Username" value={this.state.email} defaultValue={this.props.user.email} onChange={this.onChange} disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true} />
                        </Col>
                    </Form.Group>
                    {!this.props.user.userID && (
                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                Password&nbsp;<span style={{ color: 'red' }}>*</span>
                            </Form.Label>
                            <Col sm={5}>
                                <Form.Control id="password" type="password" placeholder="password" value={this.state.password} onChange={this.onChange} />
                                <span style={{fontStyle: 'italic', fontWeight: '600', fontSize: '12px'}}>*Password must contain 8 characters, at least one letter, one number and a symbol</span>
                            </Col>
                        </Form.Group>
                    )}
                    <Form.Group as={Row}>
                        <Form.Label column sm={2}>
                            Primary Phone&nbsp;<span style={{ color: 'red' }}>*</span>
                    </Form.Label>
                        <Col sm={10}>
                            <Form.Control id="phone" type="tel" placeholder="Phone" maxLength="31" value={this.state.phone} onChange={this.onChange} defaultValue={this.props.user.phone} disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true} />
                        </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                Gender
                            </Form.Label>
                            <Col sm={8}>
                                <Form.Control as="select" id="gender" value={this.state.gender} onChange={this.onChange} disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true}>
                                    <option value="">Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Non-binary">Non-binary</option>
                                    <option value="No Preference">No Preference</option>
                                </Form.Control>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                Age Range
                            </Form.Label>
                            <Col sm={8}>
                                <Form.Control as="select" id="ageRange" value={this.state.ageRange} onChange={this.onChange} disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true}>
                                    <option value="">Select Age Range</option>
                                    <option value="20-40">20-40</option>
                                    <option value="40-60">40-60</option>
                                    <option value="60+">60+</option>
                                    <option value="No Preference">No Preference</option>
                                </Form.Control>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                Location
                            </Form.Label>
                            <Col sm={8}>
                                <Form.Control as="select" id="location" value={this.state.location} onChange={this.onChange} disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true}>
                                    <option value="">Select Location</option>
                                    <optgroup label="Australia">
                                        <option value="Australia - Perth">Perth</option>
                                        <option value="Australia - Brisbane">Brisbane</option>
                                    </optgroup>
                                    <optgroup label="Canada">
                                        <option value="Canada - British Columbia">British Columbia</option>
                                        <option value="Canada - Central">Central</option>
                                    </optgroup>
                                    <optgroup label="Germany">
                                        <option value="Germany - Munich">Munich</option>
                                        <option value="Germany - Frankfurt">Frankfurt</option>
                                        <option value="Germany - Berlin">Berlin</option>
                                        <option value="Germany - Rhine-Ruhr">Rhine-Ruhr</option>
                                    </optgroup>
                                    <optgroup label="Hong Kong">
                                        <option value="Hong Kong - Hong Kong Island">Hong Kong Island</option>
                                        <option value="Hong Kong - Kowloon Peninsula">Kowloon Peninsula</option>
                                        <option value="Hong Kong - New Territories">New Territories</option>
                                    </optgroup>
                                    <optgroup label="Japan">
                                        <option value="Japan - Hokkaido">Hokkaido</option>
                                        <option value="Japan - Tohoku">Tohoku</option>
                                        <option value="Japan - Kanto">Kanto</option>
                                        <option value="Japan - Chubu">Chubu</option>
                                        <option value="Japan - Kinki">Kinki</option>
                                        <option value="Japan - Chugoku">Chugoku</option>
                                        <option value="Japan - Shikoku">Shikoku</option>
                                        <option value="Japan - Kyushu-Okinawa">Kyushu-Okinawa</option>
                                    </optgroup>
                                    <optgroup label="United States">
                                        <option value="United States - East Coast">East Coast</option>
                                        <option value="United States - West Coast">West Coast</option>
                                        <option value="United States - Central">Central</option>
                                    </optgroup>
                                    <optgroup label="United Kingdom">
                                        <option value="United Kingdom - England">England</option>
                                        <option value="United Kingdom - Scotland">Scotland</option>
                                        <option value="United Kingdom - Wales">Wales</option>
                                        <option value="United Kingdom - Northern Ireland">Northern Ireland</option>
                                    </optgroup>
                                    <option value="No Preference">No Preference</option>
                                </Form.Control>
                            </Col>
                        </Form.Group>     
                        <Form.Group as={Row} className="editProfileLogoRow">
                        <Form.Label column sm={2}>
                            Affiliate Logo
                            </Form.Label>
                        <Col sm={6}><Form.Control className="smallTextBox" type="text" id="logoURL" onChange={this.onChange} value={this.state.logoURL} disabled={true} /></Col>
                        <Col sm={1}>
                            <a href={this.state.tempLogo ? this.state.tempLogo : this.state.logoURL} alt="" target="blank" rel="noopener noreferrer"><img src={this.state.tempLogo ? this.state.tempLogo : this.state.logoURL} height="60" width="" alt="" /></a>
                        </Col>
                        <Col sm={3}><input type="file" className="user-photo-input selectPhotoEditProfile" id="logoURLfile" onChange={this.onChangeFile} accept="image/*" defaultValue="" /></Col>
                    </Form.Group>

                        <Form.Group as={Row} className="editProfileIncludeLogo">
                        <Col sm={2}></Col>
                        <Col sm={6} className={this.state.logoURL ? "" : "includeLogoCheckbox"}>
                            <CheckBox style={{ marginLeft: "0px", fontSize: "30px" }} checked={this.state.includeLogoURL} onChange={this.onCheckInclude} /><br />
                            <Form.Label>Include Logo on Emails and Invoices</Form.Label>
                        </Col>
                    </Form.Group>

                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                CTP Program Name
                            </Form.Label>
                            <Col sm={8}>
                                <Form.Control as="select" id="ctpProgramName" value={this.state.ctpProgramName} onChange={this.onChange} disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true}>
                                    <option value="">Select CTP Program</option>
                                    <option value="New York">New York</option>
                                    <option value="New York Blended">New York Blended</option>
                                    <option value="San Diego">San Diego</option>
                                    <option value="Seattle">Seattle</option>
                                    <option value="Seattle Mid-Week Virtual">Seattle Mid-Week Virtual</option>
                                    <option value="Washington D.C.">Washington D.C.</option>
                                    <option value="Victoria">Victoria</option>
                                    <option value="Chicago">Chicago</option>
                                    <option value="East Coast Virtual">East Coast Virtual</option>
                                    <option value="West Coast Virtual">West Coast Virtual</option>
                                    <option value="Midwest Virtual">Midwest Virtual</option>
                                    <option value="Autumn Virtual">Autumn Virtual</option>
                                    <option value="Winter Virtual">Winter Virtual</option>
                                    <option value="Summer Virtual">Summer Virtual</option>
                                </Form.Control>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                CTP Program Year
                            </Form.Label>
                            <Col sm={4}>
                                <Form.Control 
                                    id="ctpProgramYearStart" 
                                    type="text" 
                                    placeholder="Start Year (e.g., 2016)" 
                                    maxLength="4"
                                    value={this.state.ctpProgramYearStart} 
                                    onChange={this.onChange}
                                    disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true} />
                            </Col>
                            <Col sm={4}>
                                <Form.Control 
                                    id="ctpProgramYearEnd" 
                                    type="text" 
                                    placeholder="End Year (e.g., 2017)" 
                                    maxLength="4"
                                    value={this.state.ctpProgramYearEnd} 
                                    onChange={this.onChange}
                                    disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true} />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                ICF Credentials
                            </Form.Label>
                            <Col sm={8}>
                                <Form.Control as="select" id="icfCredentials" value={this.state.icfCredentials} onChange={this.onChange} disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true}>
                                    <option value="">Select ICF Credential</option>
                                    <option value="Associate Certified Coach (ACC)">Associate Certified Coach (ACC)</option>
                                    <option value="Professional Certified Coach (PCC)">Professional Certified Coach (PCC)</option>
                                    <option value="Master Certified Coach (MCC)">Master Certified Coach (MCC)</option>
                                    <option value="Accomplishment Coaching Certified Coach">Accomplishment Coaching Certified Coach</option>
                                    <option value="No Preference">No Preference</option>
                                </Form.Control>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                Other Professional Credentials
                            </Form.Label>
                            <Col sm={8}>
                                <Form.Control 
                                    id="otherProfessionalCredentials" 
                                    type="text" 
                                    placeholder="Other Professional Credentials" 
                                    value={this.state.otherProfessionalCredentials} 
                                    onChange={this.onChange}
                                    disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true} />
                            </Col>
                        </Form.Group>
          
                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                Website
                            </Form.Label>
                            <Col sm={8}>
                                <Form.Control id="website" onChange={this.onChange} value={this.state.website} defaultValue={this.props.user.website} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                Business Email
                            </Form.Label>
                            <Col sm={8}>
                                <Form.Control id="businessEmail" type="email" placeholder="Business Email" onChange={this.onChange} value={this.state.businessEmail} defaultValue={this.props.user.businessEmail} disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                Coaching Type
                            </Form.Label>
                            <Col sm={8} style={{ display: 'flex', flexWrap: 'wrap' }}>
                                {COACHING_TYPE_OPTIONS.map((option) => (
                                    <Form.Check
                                        key={option}
                                        type="checkbox"
                                        id={`admin-coachingType-${option.replace(/\s+/g, '-')}`}
                                        label={option}
                                        checked={parseCoachingTypes(this.state.coachingType).includes(option)}
                                        onChange={() => this.onToggleCoachingType(option)}
                                        disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true}
                                        style={{ width: '50%', marginBottom: 4 }}
                                    />
                                ))}
                            </Col>
                        </Form.Group>
                        {parseCoachingTypes(this.state.coachingType).includes("Other") && (
                            <Form.Group as={Row}>
                                <Form.Label column sm={2}>
                                    &nbsp;
                                </Form.Label>
                                <Col sm={8}>
                                    <Form.Control 
                                        id="coachingTypeOther" 
                                        type="text" 
                                        placeholder="Please specify coaching type" 
                                        value={this.state.coachingTypeOther} 
                                        onChange={this.onChange}
                                        disabled={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? false : true} />
                                </Col>
                            </Form.Group>
                        )}
                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                Company Name
                            </Form.Label>
                            <Col sm={8}>
                                <Form.Control id="companyName" onChange={this.onChange} value={this.state.companyName} defaultValue={this.props.user.companyName} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="editProfileIncludeLogo">
                            <Col sm={2}></Col>
                            <Col sm={6} className={this.state.logoURL ? "" : "includeLogoCheckbox"}>
                                <CheckBox style={{ marginLeft: "0px", fontSize: "30px" }} checked={this.state.canAccessDocs} onChange={this.onCheckAccessDocs} /><br />
                                <Form.Label>Can Access Docs?</Form.Label>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Col sm={2}></Col>
                            <Col sm={6}>
                                <CheckBox style={{ marginLeft: "0px", fontSize: "30px" }} checked={this.state.isLive} onChange={this.onCheckCoachApproval} /><br />
                                <Form.Label>Coach Approved? (It will depend if it appears in the coach finder page)</Form.Label>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2}>
                                Affiliate Fee Type
                            </Form.Label>
                        <Col sm={8}>

                            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                                <DropdownToggle className="ddStyle" caret>
                                    {this.state.affiliateFeeType ? this.state.affiliateFeeType + ' ' : "Select Affiliate Fee Type"}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem header>Affiliate Fee Type</DropdownItem>
                                    <DropdownItem disabled>{this.state.affiliateFeeType} <i>(current selection)</i></DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem></DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Standard USA") }>Standard USA</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Standard Canadian")}>Standard Canadian</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Flat Rate USA") }>Flat Rate USA</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Flat Rate Canadian")}>Flat Rate Canadian</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Standard USA & Canadian")}>Standard USA & Canadian</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Flat Rate USA & Canadian")}>Flat Rate USA & Canadian</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Leader Standard USA")}>Leader Standard USA</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Leader Standard Canadian")}>Leader Standard Canadian</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Standard USA - No Fee")}>Standard USA - No Fee</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Standard Canadian - No Fee")}>Standard Canadian - No Fee</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Leader Standard USA - No Fee")}>Leader Standard USA - No Fee</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Leader Standard Canada - No Fee")}>Leader Standard Canada - No Fee</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Standard Canadian & USA")}>Standard Canadian & USA</DropdownItem>
                                    <DropdownItem className="text-primary" onClick={() => this.onChangeAffiliateType("Standard USA & Canadian – No Fee")}>Standard USA & Canadian – No Fee</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>

                        </Col>
                        </Form.Group>
                    <Form.Group as={Row}>
                        <center><div className="loginModalFooter">{this.props.message}</div></center>
                    </Form.Group>
                    <Form.Group as={Row}>
                        <Col sm={2} width="50px">
                                <button className="button-gridrow-edit-profile " href="#" onClick={this.onClick}>SAVE</button>
                        </Col>
                        { (this.props.user.userID && this.props.user.isActive) ? (
                            <Col sm={2} width="50px">
                                <button className={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? 'button-gridrow-edit-profile' : 'hidden'} onClick={this.onClickDeactivate}>DEACTIVATE</button>
                            </Col>
                        ) : (<></>)}
                        { (this.props.user.userID && !this.props.user.isActive) ? (
                            <Col sm={2} width="50px">
                                <button className={(this.props.sysUser.userRole === 8 || this.props.sysUser.userRole === 37) || (this.props.user.userRole !== 8 && this.props.user.userRole !== 37) ? 'button-gridrow-edit-profile' : 'hidden'} onClick={this.onClickReactivate}>REACTIVATE</button>
                            </Col>
                        ) : (<></>)}

                        <Col sm={2} width="50px">
                                <button className="button-gridrow-edit-profile" href="#" onClick={this.onClickCancel}>CANCEL</button>
                        </Col> 

                        <Col sm={2} width="50px">
                            &nbsp;
                            </Col>
                        <Col sm={4}>
                            <span style={{ color: 'red' }}>* Required Field</span>
                        </Col>

                        </Form.Group>
                    </Container>                    
                </Modal.Body>           
        );
    }
}

function mapStateToProps(state) {
    return {
        token: state.loginReducer.loginToken,
        message: state.loginReducer.message,
        sysUser: state.loginReducer.sysUser,
    }
}
export default connect(mapStateToProps, { register, getContactsByUser, editUserProfile, showEditUserForm, saveIcon, deactivateUser, reactivateUser })(UserProfile);

